import apiClient from "../api/apiClient"
import { SKU, CreateSKUForm, SKUApiResponse } from "../../types"

export const skuService = {
  async getSKUs(params?: {
    page?: number
    limit?: number
    search?: string
    active_only?: boolean
  }): Promise<SKUApiResponse> {
    const response = await apiClient.get<SKUApiResponse>("/sku/get-all", { params })
    return response.data
  },

  async getSKUById(id: string): Promise<SKU> {
    const response = await apiClient.get<SKU>(`/sku/${id}`)
    return response.data
  },

  async createSKU(skuData: CreateSKUForm): Promise<SKU> {
    const response = await apiClient.post<SKU>("/sku/create", skuData)
    return response.data
  },

  async createSKUAtPosition(skuData: CreateSKUForm): Promise<SKU> {
    const response = await apiClient.post<{ sku: SKU }>("/admin/sku/create-at-position", skuData)
    return response.data.sku
  },

  async updateSKU(id: string, skuData: Partial<CreateSKUForm>): Promise<SKU> {
    const response = await apiClient.put<SKU>(`/sku/${id}`, skuData)
    return response.data
  },

  async updateSKUAtPosition(id: string, skuData: Partial<CreateSKUForm>): Promise<SKU> {
    const response = await apiClient.put<{ sku: SKU }>(`/admin/sku/update-at-position/${id}`, skuData)
    return response.data.sku
  },

  async updateSKUStatus(id: string, isActive: boolean): Promise<SKU> {
    const response = await apiClient.patch<{ sku: SKU }>(`/sku/${id}/status`, {
      is_active: isActive,
    })
    return response.data.sku
  },

  async deleteSKU(id: string): Promise<void> {
    await apiClient.delete(`/sku/${id}`)
  },

  async updateSKUSortOrder(skuIds: string[]): Promise<void> {
    await apiClient.put("/admin/sku/sort-order/update", { skuIds })
  },
}
